const INITIAL = { version: 0 };

export default function labels(state = INITIAL, action) {
  switch (action.type) {
    case 'LABELS_PRINTED': {
      return { ...state, version: state.version + 1 };
    }
    case 'RESET_LABELS_VERSION': {
      return { ...state, version: 0 };
    }
    default:
      return state;
  }
}

export const labelsPrinted = () => ({ type: 'LABELS_PRINTED' });
export const resetLabelsVersion = () => ({ type: 'RESET_LABELS_VERSION' });
